import { COHORTS, useCohort } from "@/components/user-context";

import { LoggedInJiraNewUser } from "../components/logged-in-jira-new-user";

import { LoggedInJiraStandardExistingUser } from "./existing-user";
import { LoggedInJiraStandardUpgradeEligibleUser } from "./upgrade-eligible-user";

export const LoggedInJiraStandard = () => {
    const cohort = useCohort();

    if (cohort === COHORTS.NEW_USER) {
        return <LoggedInJiraNewUser />;
    }

    if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER) {
        return <LoggedInJiraStandardUpgradeEligibleUser />;
    }

    if (cohort) {
        return <LoggedInJiraStandardExistingUser />;
    }

    return null;
};
